import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Programs = lazy(() => import('../pages/programs/page'));
const ProgramDetail = lazy(() => import('../pages/programs/ProgramDetail'));
const Courses = lazy(() => import('../pages/courses/page'));
const Resources = lazy(() => import('../pages/resources/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Apply = lazy(() => import('../pages/apply/page'));
const ApplicationConfirmation = lazy(() => import('../pages/apply/confirmation'));
const AdminLogin = lazy(() => import('../pages/admin/login'));
const AdminApplications = lazy(() => import('../pages/admin/applications'));
const Assessment = lazy(() => import('../pages/assessment/page'));
const AssessmentLidership = lazy(() => import('../pages/assessmentLidership/assessmentLidership'));
const AssessmentHR = lazy(() => import('../pages/assessmentHR/assessmentHR'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/programs',
    element: <Programs />,
  },
  {
    path: '/programs/:slug',
    element: <ProgramDetail />,
  },
  {
    path: '/courses',
    element: <Courses />,
  },
  {
    path: '/resources',
    element: <Resources />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/apply',
    element: <Apply />,
  },
  {
    path: '/apply/confirmation',
    element: <ApplicationConfirmation />,
  },
  {
    path: '/assessment',
    element: <Assessment />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/applications',
    element: <AdminApplications />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
  {
    path: '/assessment-lidership',
    element: <AssessmentLidership />,
  },
  {
    path: '/assessment-hr',
    element: <AssessmentHR />,
  }

];

export default routes;
